/**
 * How a value behaves when it outgrows its column — reference §4.
 *
 * Two cases, and the split is not stylistic:
 *
 * - **One word** has nowhere to break, so wrapping would either overflow the cell or force
 *   a mid-word break that changes what the value looks like. It ellipsizes, and the full
 *   text stays reachable through a `title`.
 * - **More than one word** breaks at its spaces and wraps, because an ellipsized sentence
 *   loses the end of itself with no way to get it back.
 *
 * Lives here rather than in each cell so `<TextCell>` and `<StackedCell>` cannot drift into
 * treating the same value differently in adjacent columns.
 */
export interface OverflowBehaviour {
  /** Tailwind class governing the overflow. */
  className: 'truncate' | 'break-words';
  /** Set only when the value ellipsizes, so nothing is unreachable. */
  title?: string;
}

export function describeOverflow(value: string): OverflowBehaviour {
  // A single token by the only test that matters here: is there a space to break at.
  const singleToken = !value.trim().includes(' ');

  return singleToken ? { className: 'truncate', title: value } : { className: 'break-words' };
}
